import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants'
import Swiper, { A11y, Navigation } from 'swiper'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
Swiper.use([A11y, Navigation])

const SELECTORS = {
  gallery: '.js-gallery',
  swiper: '.js-gallery__swiper',
  navNext: '.js-gallery__swiper_nav--next',
  navPrev: '.js-gallery__swiper_nav--prev'
}

class Gallery {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.wrapper = this.element.querySelector(SELECTORS.wrapper)
    this.galleryType = this.element.dataset.type
    this.swiper = this.element.querySelector(SELECTORS.swiper) ? `#${this.element.querySelector(SELECTORS.swiper).id}` : null
    this.navNext = this.element.querySelector(SELECTORS.navNext) ? `#${this.element.querySelector(SELECTORS.navNext).id}` : null
    this.navPrev = this.element.querySelector(SELECTORS.navPrev) ? `#${this.element.querySelector(SELECTORS.navPrev).id}` : null
    this.slideshow = null
    this.throttleResize = null
    this.init()
  }

  init() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.IS_MOBILE, ({ isMobile }) => {
      if (isMobile) {
        this.createCarousel()
      } else {
        if (this.slideshow !== null && 'destroy' in this.slideshow) {
          this.slideshow.destroy(true, true)
        }
      }
    })
  }

  createCarousel() {
    if (
      this.galleryType.includes('dynamic') ||
      !this.swiper.length ||
      !this.element.classList.contains('js-gallery') ||
      (this.slideshow && this.slideshow.initialized)
    ) {
      return
    }

    this.slideshow = new Swiper(this.swiper, {
      slidesPerView: 1.25,
      centeredSlides: false,
      spaceBetween: 15,
      a11y: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1
      },
      freeMode: {
        enabled: true,
        sticky: true,
        momentumBounce: false
      },
      breakpoints: {
        768: {
          spaceBetween: 32,
          slidesPerView: 'auto'
        }
      },
      navigation: {
        nextEl: this.navNext,
        prevEl: this.navPrev
      }
    })
  }
}

/**
 * Add module objects alphabetically as needed
 * {
 *  selector: CSS selector for the target element(s)
 *  Source: Imported js class with a constructor. Constructor will be passed
 *      the target DOM element.
 * }
 */
export default {
  selector: SELECTORS.gallery,
  Source: Gallery
}
